class RedPanikHastaListesiResponse {
    id: number = 0;
    hastaadsoyad: string = "";
    okundu: number = 0;
    okunacak: number = 0;
    okunduBilgi: string = "";
}
export default RedPanikHastaListesiResponse;